import React from 'react';

import { Icon } from '@chakra-ui/react';

export const RepoProjectIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <path
          d="M940 390C940 503.137 940 559.706 904.853 594.853 869.706 630 813.137 630 700 630L580 630C466.864 630 410.293 630 375.148 594.853 340 559.706 340 503.137 340 390L340 330C340 216.864 340 160.293 375.148 125.148 410.293 90 466.864 90 580 90L700 90C813.137 90 869.706 90 904.853 125.148 940 160.293 940 216.864 940 330L940 390Z"
          stroke="currentColor"
          strokeWidth="39.9999"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M550 90 550 630"
          stroke="currentColor"
          strokeWidth="39.9999"
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
      </g>
    </g>
  </Icon>
);
